"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const context_1 = require("context");
const utils_1 = require("utils");
const actions_1 = require("../../credit_application/actions");
const ProveFindFormOTA_1 = __importDefault(require("../../forms/Prove/ProveFindFormOTA"));
const api_1 = require("./utils/api");
const FindOTA = () => {
    // Hooks
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const { search } = (0, react_router_dom_1.useLocation)();
    const query = (0, utils_1.parseQuery)(search);
    const token = query[config_1.QUERY_KEY.TOKEN];
    // State
    const [isAvailable, setIsAvailable] = (0, react_1.useState)(null);
    const handleSuccess = (0, react_1.useCallback)(() => {
        analytics?.track('SubmitInitialProveFormOTA', {});
    }, [location, analytics]);
    const handleSkipButton = () => {
        dispatch((0, actions_1.setProveBypass)(true)); // Record Bypass
        if (location.state?.practice && location.state?.practice.adsStoreNumber) {
            history.push({
                pathname: (0, config_1.makeStoreUrl)(location.state?.practice.adsStoreNumber),
                search: token ? `?token=${token}` : '',
                state: {
                    practice: location.state.practice,
                },
            });
        }
        else {
            history.push('/credit-portal/apply/wizard');
        }
    };
    const handleError = (res) => {
        if (res) {
            // HyperDX Error
            (0, utils_1.reportError)('proveError', {
                componentName: 'FindInfo',
                funcName: 'handleError',
                errType: 'signup',
                errURL: window.location.pathname,
                errMsg: res?.message,
            }, res);
            analytics?.track('SubmitInitialProveFormOTAError', {});
            // Redirect to wizard
            setIsAvailable(false);
        }
    };
    const handleSubmit = (0, react_1.useCallback)(async (values) => {
        const postData = {
            phone: values.phone.replace(/[^0-9]/g, ''),
            ssn_last_4: values.ssn_last_4 ?? undefined,
            date_of_birth: values.date_of_birth ?? undefined,
            credit_application_id: location.state?.creditApplication
                ? location.state?.creditApplication.applicationId
                : undefined,
            location_id: location.state?.practice
                ? Number(location.state?.practice.locationId)
                : undefined,
        };
        dispatch((0, actions_1.setProveVerify)({
            credit_application_id: postData?.credit_application_id ?? undefined,
            location_id: postData?.location_id ?? undefined,
            session_id: null,
            phone_number: postData?.phone,
            ssn_last_4: postData?.ssn_last_4 ?? undefined,
            status: null,
            date_of_birth: (0, utils_1.formatDateFromDB)(values.date_of_birth ?? '', true) ?? undefined,
        }));
        // HyperDX Action
        (0, utils_1.reportAction)('ProveAppOTA', {
            componentName: 'FindOTA',
            actionType: 'StartProveOTA',
            actionURL: window.location.pathname,
            actionData: {
                ...postData,
            },
        });
        const storeNum = location.state?.practice?.adsStoreNumber; // Store Number
        history.push({
            pathname: (0, config_1.makeStoreUrl)(Number(storeNum)),
            search: '?token=' + token,
            state: {
                practice: location.state.practice,
            },
        });
    }, [location, analytics]);
    const init = async () => {
        sessionStorage.setItem('fromProve', 'true');
        const resp = await (0, api_1.getProveAvail)();
        const respJson = await resp.json();
        if (resp?.status === 200 && respJson?.available === true) {
            setIsAvailable(true);
        }
        else {
            setIsAvailable(false);
        }
    };
    // Effects
    (0, react_1.useEffect)(() => {
        init();
    }, []);
    (0, react_1.useEffect)(() => {
        if (isAvailable === false) {
            if (location.state?.practice && location.state?.practice.adsStoreNumber) {
                history.push({
                    pathname: (0, config_1.makeStoreUrl)(location.state?.practice.adsStoreNumber),
                });
            }
            else {
                history.push(`/credit-portal/apply/wizard`);
            }
        }
    }, [isAvailable]);
    (0, react_1.useEffect)(() => {
        analytics?.track('LandProvePage', {});
    }, [analytics]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [isAvailable && ((0, jsx_runtime_1.jsx)(ProveFindFormOTA_1.default, { skipFunc: handleSkipButton, submitFunc: handleSubmit, onSubmitSuccess: handleSuccess, onSubmitFail: handleError })), isAvailable === null && (0, jsx_runtime_1.jsx)(components_1.Spinner, {})] }));
};
exports.default = FindOTA;
